export interface Article {
  id: string;
  title: string;
  summary: string;
  date: string;
  dramaId: string;
  category: string;
  readTime: string;
  cover: string;
}

export const articles: Article[] = [
  {
    id: "a-001",
    title: "《风流女管家》结局解析：苏曼姝的“放下”，才是真正的赢",
    summary:
      "大结局看似团圆，实则藏着一层更深的意味。本文从三处细节出发，拆解苏曼姝最后那个转身背后的选择逻辑。",
    date: "2024-03-22",
    dramaId: "fengliu-nvguandian",
    category: "剧情解析",
    readTime: "8 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20close%20up%20of%20a%20woman%20in%20dark%20red%20qipao%20turning%20away%20at%20a%20mansion%20gate%2C%20warm%20amber%20light%2C%20moody%20period%20drama%20still&width=800&height=500&seq=article-fengliu-ending&orientation=landscape",
  },
  {
    id: "a-002",
    title: "从账本到布庄：聊聊苏曼姝的“商业脑”是怎么一步步长出来的",
    summary:
      "她不是天生会做生意。剧集用三个关键节点，让一个女管家的谋略变得可信。本文梳理这条完整的成长弧线。",
    date: "2024-03-19",
    dramaId: "fengliu-nvguandian",
    category: "人物分析",
    readTime: "6 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20ledger%20book%20and%20abacus%20on%20a%20wooden%20desk%20with%20warm%20lamp%20light%2C%20period%20drama%20still%20life%2C%20rich%20burgundy%20and%20gold%20tones&width=800&height=500&seq=article-fengliu-business&orientation=landscape",
  },
  {
    id: "a-003",
    title: "顾廷之为什么“不敢”爱？一个克制型男主的心理侧写",
    summary:
      "所有深情的背后都是恐惧。本文借顾廷之的三次欲言又止，聊聊这个角色被观众反复讨论的原因。",
    date: "2024-03-16",
    dramaId: "fengliu-nvguandian",
    category: "人物分析",
    readTime: "7 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20close%20up%20of%20a%20stern%20man%20in%20a%20dark%20suit%20by%20a%20rainy%20window%2C%20warm%20amber%20reflection%2C%20moody%20period%20drama%20still&width=800&height=500&seq=article-fengliu-gu&orientation=landscape",
  },
  {
    id: "a-004",
    title: "《风流女管家》名场面盘点：这五场戏值得反复看",
    summary:
      "从夜宴到码头，剧集贡献了不止一个高光时刻。本文按时间线整理五场最具代表性的名场面，并附拍摄花絮。",
    date: "2024-03-13",
    dramaId: "fengliu-nvguandian",
    category: "名场面",
    readTime: "5 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20vintage%20banquet%20hall%20with%20lanterns%20and%20long%20table%2C%20elegant%20period%20drama%20atmosphere%2C%20amber%20and%20burgundy%20tones&width=800&height=500&seq=article-fengliu-scenes&orientation=landscape",
  },
  {
    id: "a-005",
    title: "沈知微：那个“新女性”为什么让观众意难平",
    summary:
      "她带着新思想闯入旧家族，注定格格不入。本文聊聊沈知微这个角色的时代意义，以及她与苏曼姝的镜像关系。",
    date: "2024-03-09",
    dramaId: "fengliu-nvguandian",
    category: "人物分析",
    readTime: "6 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20young%20woman%20reading%20a%20book%20by%20a%20sunlit%20window%2C%20cream%20and%20warm%20tones%2C%20refined%20period%20drama%20still&width=800&height=500&seq=article-fengliu-shen&orientation=landscape",
  },
  {
    id: "a-006",
    title: "《锦上往事》与非遗苏绣：一部剧如何让传统手艺“出圈”",
    summary:
      "剧中的每一幅绣品都有实物参考。本文带你了解剧组与绣娘团队的合作幕后，以及苏绣为何打动了年轻观众。",
    date: "2023-09-12",
    dramaId: "jinshang-wangshi",
    category: "幕后花絮",
    readTime: "6 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20colorful%20silk%20embroidery%20on%20a%20bamboo%20frame%20in%20a%20sunlit%20workshop%2C%20warm%20dusty%20light%2C%20artisan%20craft%20atmosphere&width=800&height=500&seq=article-jinshang-craft&orientation=landscape",
  },
  {
    id: "a-007",
    title: "《城市灯塔》救援戏为何如此真实？实拍幕后揭秘",
    summary:
      "为了呈现逼真的火场环境，剧组做了哪些准备？本文探访拍摄现场，还原几个高难度救援段的拍摄过程。",
    date: "2024-08-24",
    dramaId: "chengshi-dengta",
    category: "幕后花絮",
    readTime: "5 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=nighttime%20city%20street%20with%20emergency%20lights%20and%20warm%20glow%2C%20rain%20reflections%20on%20asphalt%2C%20cinematic%20urban%20drama%20still&width=800&height=500&seq=article-dengta-behind&orientation=landscape",
  },
  {
    id: "a-008",
    title: "《古韵长安》的礼制考据：一场朝会背后有多少讲究",
    summary:
      "从站位到服色，古装剧的每一个细节都是学问。本文以朝会戏为例，解析剧组在礼制还原上的用心。",
    date: "2024-01-15",
    dramaId: "guyun-changan",
    category: "幕后花絮",
    readTime: "7 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=grand%20ancient%20Chinese%20throne%20hall%20with%20lanterns%20and%20rows%20of%20standing%20court%20officials%2C%20golden%20warm%20light%2C%20epic%20period%20drama%20still&width=800&height=500&seq=article-changan-ritual&orientation=landscape",
  },
];